<nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
  <div class="container-fluid">
    <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block mr-4" routerLinkActive="active"
      [routerLink]="['/board/dashboard']">{{getTitle()}}</a>
  </div>
</nav>